import { render, staticRenderFns } from "./FollowupTable.vue?vue&type=template&id=7e85f83b&"
import script from "./FollowupTable.vue?vue&type=script&lang=js&"
export * from "./FollowupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports